module.exports = __webpack_public_path__ + "static/media/minus.653e87e9.svg";